import { useSessionStorage } from 'hooks/useSessionStorage';
import { useEffect, useState } from 'react';
import { verifyIsCompanyPermited } from 'utils/checkFunctionalityPermission';
import { SummaryJobRiskFactors } from '../../SummaryRisk.types';
import { downloadFile } from '../../services';
import { useToast } from '@welbe/web-design-system';

export const useModalFactor = () => {
	const { toast } = useToast();
	const { getSessionStorage } = useSessionStorage();
	const [isCompanyPermited, setIsCompanyPermited] = useState<
		boolean | undefined
	>(false);
	const [loadingFile, setLoadingFile] = useState(false);

	const handleOpenFile = async (factor: SummaryJobRiskFactors) => {
		try {
			setLoadingFile(true);
			const { data } = await downloadFile(factor.jobProfileRiskFactorId);
			window.open(data?.content);
		} catch {
			toast.error('Hubo un error al intentar abrir lo documento.');
		} finally {
			setLoadingFile(false);
		}
	};

	const getMeInfo = async () => {
		try {
			const meCompany = getSessionStorage('me');
			if (meCompany) {
				setIsCompanyPermited(
					verifyIsCompanyPermited(JSON.parse(meCompany).company, 'campaigns'),
				);
			}
		} catch (error) {
			console.error(error);
		}
	};

	const handleOpenChat = () => {
		if (window.fcWidget) {
			window.fcWidget.open();
		}
	};

	useEffect(() => {
		getMeInfo();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return { isCompanyPermited, loadingFile, handleOpenChat, handleOpenFile };
};
